import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowRefService {
  get nativeWindow(): Window {
    return window;
  }

  // Adicione métodos para manipular o objeto window, se necessário
  navigateTo(url: string): void {
    this.nativeWindow.location.href = url;
  }

  getLocalStorageItem(key: string): string | null {
    return this.nativeWindow.localStorage.getItem(key);
  }

  setLocalStorageItem(key: string, value: string): void {
    this.nativeWindow.localStorage.setItem(key, value);
  }

  removeLocalStorageItem(key: string): void {
    this.nativeWindow.localStorage.removeItem(key);
  }
}
